import { useQuery } from '@tanstack/react-query';

import { PricingPlan } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/pricing/pricing-plan/:planId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    planId: string;
    parkingId: string;
}
const queryFn = ({ planId, parkingId }: DTO): Promise<PricingPlan> => {
    return axios.get(formatResourcePath(RESOURCE, { planId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as GET_PRICING_PLAN_RESOURCE, useQueryHook as useGetPricingPlan };
